import React from "react";
import { cn } from "../../../utils";
import { GroupProps } from "../types";

export const Group = React.forwardRef<HTMLDivElement, GroupProps>(
  ({ direction = "horizontal", className: propsClassName, ...rest }, ref) => {
    const className = cn(
      "flex flex-row gap-6",
      {
        "flex-col": direction === "vertical",
      },
      propsClassName,
    );

    return <div ref={ref} className={className} {...rest} />;
  },
);

Group.displayName = "FormGroup";
